import { MessageSeverity } from "primereact/api";

import { WhitelabelApi, WhitelabelSettingReadModel } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IStoreContext } from "../../stores/StoreContext";
import { WhitelabelApiService } from "../ApiServices/WhitelabelApiService";
import { GenericService } from "../GenericService";

export class WhitelabelService extends GenericService<WhitelabelApi, WhitelabelApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, WhitelabelApi, WhitelabelApiService);
  }

  public async getGeneralSettings(): Promise<WhitelabelSettingReadModel[]> {
    const settingsList: WhitelabelSettingReadModel[] = await this.apiService.whitelabelGetSettings();
    this.storeContext.whitelabelStore.whitelabelSettings = settingsList;

    return settingsList;
  }

  public async getSettingImage(): Promise<Blob> {
    let appLogo = this.storeContext.whitelabelStore.appLogo;

    if (!appLogo) {
      appLogo = await this.apiService.whitelabelGetLogo();
      this.storeContext.whitelabelStore.updateLogo(appLogo);
    }

    return appLogo;
  }

  public async getFilteredSettings(category: string): Promise<WhitelabelSettingReadModel[]> {
    const settingsList = await this.getGeneralSettings();

    const filteredSettings = settingsList.filter(setting => setting.key.startsWith(category));

    return filteredSettings;
  }

  public updateImageSetting = async (key: string, value: File): Promise<void> => {
    await this.apiService.whitelabelUpdateLogoPut({ logo: value });

    this.showAutoSaveToast();
  };

  public async updateSetting(key: string, value: any): Promise<void> {
    await this.apiService.whitelabelUpdateSettingPut({
      whitelabelSettingWriteModel: { key, value },
    });
    this.updateSettingInStore(key, value);

    this.showAutoSaveToast();
  }

  public async resetAllSettingsToDefault(): Promise<void> {
    await this.apiService.whitelabelResetAllSettingsToDefaultPut();
    this.getGeneralSettings();

    this.showAutoSaveToast();
  }

  public async resetSettingsToDefault(key: string): Promise<void> {
    await this.apiService.whitelabelResetSettingToDefaultPut({ key });
    this.getGeneralSettings();

    this.showAutoSaveToast();
  }

  private updateSettingInStore(key: string, value: any): void {
    const whitelabelStore = this.storeContext.whitelabelStore;
    if (!whitelabelStore.whitelabelSettings) {
      return;
    }

    whitelabelStore.whitelabelSettings = whitelabelStore.whitelabelSettings
      .map(oldSetting =>
        oldSetting.key === key
          ? {
              key,
              defaultValue: oldSetting.defaultValue,
              customValue: value,
            }
          : oldSetting,
      )
      .slice();
  }

  private showAutoSaveToast(): void {
    this.storeContext.toastStore.addThrottledToast(
      {
        severity: MessageSeverity.SUCCESS,
        summary: { translationKey: translationKeys.toast.autoSave.summary },
        detail: { translationKey: translationKeys.toast.autoSave.detail },
        position: "top-right",
        life: 3000,
        replace: true,
      },
      1000,
    );
  }
}
